/*
 * @Author: your name
 * @Date: 2021-03-10 15:38:30
 * @LastEditTime: 2021-03-16 17:14:35
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \zlt-front-end\src\utils\auth.js
 */
import Cookies from 'js-cookie'
import global from '../../static/global'

const TokenKey = 'Admin-Token'

export function getToken() {
  return Cookies.get(TokenKey,{domain:global.cookiePath})
}

export function setToken(token) {
  return Cookies.set(TokenKey, token,{domain:global.cookiePath})
}

export function removeToken() {
  return Cookies.remove(TokenKey,{domain:global.cookiePath})
}


// WEBPACK FOOTER //
// ./src/utils/auth.js